import { useTranslation } from 'react-i18next';

import type { UserLanguage } from '~/api/user/types';

import { ColorPicker, ExternalLink, LanguageSelect, Logo, Separator } from '~/components';
import { useColorThemeContext } from '~/providers/ColorThemeProvider/ColorThemeProvider.context';
import { useLanguageContext } from '~/providers/LanguageProvider/LanguageProvider.context';

import { headerContainerStyle, headerStyle, headerWrapperStyle, logoStyle, separatorStyle } from './AuthLayoutHeader.css';

const availableLanguages = ['nl', 'fr'] satisfies UserLanguage[];

export const AuthLayoutHeader = () => {
  const { colorTheme, setColorTheme } = useColorThemeContext();
  const { language, setLanguage } = useLanguageContext();

  const { t } = useTranslation(['auth']);

  return (
    <div className={headerStyle}>
      <div className={headerContainerStyle}>
        <ExternalLink aria-label={t('auth:logo')} href={`https://www.creativeshelter.be?color-mode=${colorTheme}`}>
          <Logo className={logoStyle} />
        </ExternalLink>

        <div className={headerWrapperStyle}>
          <ColorPicker onSelect={setColorTheme} value={colorTheme} />

          <Separator className={separatorStyle} orientation="vertical" />

          <LanguageSelect
            languages={availableLanguages}
            onValueChange={(language: UserLanguage | null) => language && setLanguage(language)}
            value={language ?? 'nl'}
          />
        </div>
      </div>
    </div>
  );
};
